import { put, call, take, fork } from 'redux-saga/effects'
import { questionMediaAddService } from '../../api/question'
//import { questionMediaAddSuccess } from '../../reducers/question/action'
import { questionMediaAddSuccess } from '../../reducers/assignment/action'
import { QUESTION_MEDIA_ADD } from '../../reducers/question/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* questionMediaAddFlow(payload) {
  try {
    const { entity, callback } = payload
    const response = yield call(questionMediaAddService, entity)
    yield put(questionMediaAddSuccess(response.data))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* questionMediaAddWatcher() {
  while (true) {
    const action = yield take(QUESTION_MEDIA_ADD)
    const { payload } = action

    yield fork(generalSaga, questionMediaAddFlow, payload)
  }
}
